<div class="mb-6">

  <div [formGroup]="filtri">

    <!-- filtri iscritti -->
    <div  class="flex flex-column align-items-center sm:flex-row mb-5 pt-5">

      <!-- ricerca iscritti o altri elementi -->
      <div class="mb-5 sm:mb-0 sm:mr-3">
        <span class="p-input-icon-left p-input-icon-right p-float-label">
          <i class="pi pi-search"></i>
          <input type="text" id="cercaIscritto" class="shadow-4" pInputText formControlName="inserimento" />
          <label for="cercaIscritto">
            {{ translate.instant('gestioneAlbo.provvisori.filtri.cerca') }}
          </label>
          <i class="pi pi-times pr-1" id="clearIcon" (click)="resetBoxRicerca()"></i>
        </span>
      </div>

      <div class="flex bottoniStyle">
        <p-button
          type="button"
          routerLink="/gestione_albo/nuovo_provvisorio"
          icon="pi pi-plus"
          iconPos="right"
          [pTooltip]="translate.instant('tooltip.inserisciProvvisorio')"
          tooltipPosition="bottom"
          [disabled]="!role_service.isIscrizioniRole()"></p-button>
      </div>

    </div>

    <!-- avanzati -->
    <div class="flex align-items-center justify-content-center sm:justify-content-start mb-5 flex-wrap gap-3">
      <div>
        <p-dropdown
          formControlName="sezione"
          [showClear]="true"
          [options]="sezioniOptions"
          optionLabel="nome"
          [placeholder]="translate.instant('gestioneAlbo.provvisori.filtri.sezione')" />
      </div>
      <div>
        <p-dropdown
          formControlName="verificati"
          [showClear]="true"
          [options]="verificatoOptions"
          optionLabel="nome"
          optionValue="valore"
          [placeholder]="translate.instant('gestioneAlbo.provvisori.filtri.scegli')" />
      </div>

      <p-button
        class="clearFiltri"
        size="small"
        [outlined]="true"
        icon="pi pi-filter-slash"
        (click)="clearFilters()"
        [pTooltip]="translate.instant('tooltip.pulisciFiltri')"
        tooltipPosition="right"
      />
    </div>

  </div>

  <div class="mb-5">

    <!-- PAGINATOR della tabella -->
    <div class="flex justify-content-start">
      <p-paginator
        [rows]="pageSize"
        [first]="currentPage"
        [rowsPerPageOptions]="[25, 100, 250, 500]"
        (onPageChange)="pageChange($event)"
        [totalRecords]="totaleDati"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} di {totalRecords}"
        [showPageLinks]="false"
      >
      </p-paginator>
    </div>

  </div>

  <!-- tabella -->
  <div>
    <p-table
      #dt
      [value]="listaProvvisori"
      [rowHover]="true"
      (onLazyLoad)="ordinamento($event)"
      [customSort]="true"
      [lazy]="true"
      [sortField]="orderColumnName"
      [sortOrder]="orderCustom(order)">
      <!-- headers -->
      <ng-template pTemplate="header">
        <tr>
          @for(headerName of headersTabella; track $index){
            @if(headerName == 'Verificato'){
              <th class="text-center">
                {{ headerName }}
              </th>
            }
            @else{
              <th [pSortableColumn]="headerName === 'Stato' ? '' : rowsTabella[$index]">
                {{ headerName }}
                <p-sortIcon [field]="rowsTabella[$index]"></p-sortIcon>
              </th>
            }
          }
        </tr>
      </ng-template>
      <!-- rows -->
      <ng-template pTemplate="body" let-iscritto>
        <tr style="cursor: pointer;" [routerLink]="generaRoutingLink(iscritto)">
          @for(rowName of rowsTabella; track $index){
            @if(rowName == 'provvisorioVerificato'){
              <td class="text-center">
                <p-checkbox
                  class="mr-1"
                  [binary]="true"
                  inputId="provvisorioVerificato"
                  [(ngModel)]="iscritto[rowName]"
                  (click)="verifica(iscritto); $event.stopPropagation()" />
              </td>
            }
            @else if(rowName == 'domandaData'){
              <td>{{ iscritto[rowName] | date: 'dd/MM/yyyy' }}</td>
            }
            @else{
              <td>{{ iscritto[rowName] }}</td>
            }
          }
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-toast position="bottom-center"></p-toast>

</div>
